/**
 * Define providers for Services defined in V1, so they can be injectable.
 */

/**
 * PulseContextService
 */
// Have to hard code service name here because compiler can't resolve namespace 
// and eval("Pulse.Services.PulseContextService.serviceId") won't work for production builds due to minification.;
export const v1_pulseContextServiceName: string = "pulseContextService";
export function pulseContextServiceFactory(injector: any) {
  return injector.get(v1_pulseContextServiceName);
}
export const pulseContextServiceProvider = {
  provide: v1_pulseContextServiceName,
  useFactory: pulseContextServiceFactory,  // Fat => function won't work in production compile.
  deps: ['$injector']
}

/** 
 * Logger service 
 * */
export const v1_loggerServiceName: string = "logger";
export function loggerServiceFactory(injector: any) {
  return injector.get(v1_loggerServiceName);
}
export const loggerServiceProvider = {
  provide: v1_loggerServiceName,
  useFactory: loggerServiceFactory,  // Fat => function won't work in production compile.
  deps: ['$injector']
}


/** 
 * Common service 
 * */
export const v1_commonServiceName: string = "common";
export function commonServiceFactory(injector: any) {
  return injector.get(v1_commonServiceName);
}
export const commonServiceProvider = {
  provide: v1_commonServiceName,
  useFactory: commonServiceFactory,  // Fat => function won't work in production compile.
  deps: ['$injector']
}

/** 
 * Breeze service 
 * */
export const v1_breezeServiceName: string = "breezeService";
export function breezeServiceFactory(injector: any) {
  return injector.get(v1_breezeServiceName);
}
export const breezeServiceProvider = {
  provide: v1_breezeServiceName,
  useFactory: breezeServiceFactory,  // Fat => function won't work in production compile.
  deps: ['$injector']
}

/** Put all services in array for easy rollup. */
export const providers: Array<any> = [pulseContextServiceProvider,
  loggerServiceProvider,
  commonServiceProvider,
  breezeServiceProvider];